(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sn-sucursales-premium"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.snCarouselArrowVersion === 2) return;
  window.snCarouselArrowVersion = 2;
  document.addEventListener('click', (event) => {
    const button = event.target.closest && event.target.closest('[data-sn-slide]');
    const shop = button && button.closest('[data-sn-shop]');
    const rail = shop && shop.querySelector('.snsl-products');
    const card = rail && rail.querySelector('.snsl-product');
    if (!card) return;
    event.preventDefault();
    event.stopPropagation();
    const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
    const step = card.getBoundingClientRect().width + gap;
    const direction = Number(button.dataset.snSlide) < 0 ? -1 : 1;
    const maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
    const target = Math.max(0, Math.min(maximum, rail.scrollLeft + direction * step));
    rail.scrollTo({left:target, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  }, true);
})();
(() => {
  if (window.snLocatorProductsBound) return;
  window.snLocatorProductsBound = true;
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-sn-variant]');
    if (!select) return;
    const card = select.closest('[data-sn-product]');
    const option = select.selectedOptions[0];
    const price = card.querySelector('[data-sn-price]');
    price.textContent = option.dataset.price;
    price.classList.toggle('snsl-sale-price', Boolean(option.dataset.compare));
    const compare = card.querySelector('[data-sn-compare]');
    compare.textContent = option.dataset.compare;
    compare.hidden = !option.dataset.compare;
    const image = card.querySelector('.snsl-product-image img');
    if (image && option.dataset.image) {
      image.removeAttribute('srcset');
      image.src = option.dataset.image;
    }
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches('.snsl-product-form')) return;
    event.preventDefault();
    if (form.dataset.busy) return;
    const shop = form.closest('[data-sn-shop]');
    const buyNow = Boolean(event.submitter && event.submitter.hasAttribute('data-sn-buy'));
    const payload = new FormData(form);
    payload.delete('return_to');
    const buttons = [...form.querySelectorAll('button')];
    const status = form.querySelector('.snsl-cart-status');
    form.dataset.busy = 'true';
    form.setAttribute('aria-busy', 'true');
    buttons.forEach(button => { button.disabled = true; });
    status.textContent = 'Agregando…';
    try {
      const response = await fetch(shop.dataset.add, {method:'POST', body:payload, headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'No se pudo agregar este producto. Revisa su disponibilidad.');
      if (buyNow) {
        const checkout = document.createElement('form');
        checkout.method = 'post'; checkout.action = shop.dataset.cart;
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = 'checkout'; input.value = 'Checkout';
        checkout.appendChild(input); document.body.appendChild(checkout); checkout.submit();
      } else {
        window.location.assign(shop.dataset.cart);
      }
    } catch (error) {
      status.textContent = error instanceof TypeError ? 'No pudimos confirmar la operación. Revisa tu carrito antes de intentarlo otra vez.' : error.message;
      buttons.forEach(button => { button.disabled = false; });
      delete form.dataset.busy;
      form.removeAttribute('aria-busy');
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
